export default __webpack_public_path__ + "static/media/roboto-v20-latin-500.f5b74d7f.woff2";